const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "outline/document"
}, /*#__PURE__*/React.createElement("g", {
  id: "Union"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7949 13.4427C11.7949 13.9037 11.6504 14.2562 11.3613 14.5004C11.0742 14.7445 10.665 14.8666 10.1338 14.8666H9.74414V16.39H8.83594V12.1068H10.2041C10.7236 12.1068 11.1182 12.2191 11.3877 12.4437C11.6592 12.6664 11.7949 12.9994 11.7949 13.4427ZM9.74414 14.1224H10.043C10.3223 14.1224 10.5312 14.0677 10.6699 13.9584C10.8086 13.847 10.8779 13.6859 10.8779 13.475C10.8779 13.2621 10.8193 13.1048 10.7021 13.0033C10.5869 12.9017 10.4053 12.8509 10.1572 12.8509H9.74414V14.1224Z",
  fill: "#6B8FBC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.1572 14.2074C16.1572 14.9125 15.9561 15.4525 15.5537 15.8275C15.1533 16.2025 14.5742 16.39 13.8164 16.39H12.6035V12.1068H13.9482C14.6475 12.1068 15.1904 12.2914 15.5771 12.6605C15.9639 13.0296 16.1572 13.5453 16.1572 14.2074ZM15.2139 14.2308C15.2139 13.3109 14.8076 12.8509 13.9951 12.8509H13.5117V15.64H13.9014C14.7764 15.64 15.2139 15.1703 15.2139 14.2308Z",
  fill: "#6B8FBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.0449 16.39H17.9385V14.6966H19.3916V13.9554H17.9385V12.8509H19.5V12.1068H17.0449V16.39Z",
  fill: "#6B8FBC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3947 2.3402L19.2949 6.46469C19.4266 6.60395 19.5 6.78834 19.5 6.98V9.25H21.25C21.6642 9.25 22 9.58579 22 10V18.5C22 18.9142 21.6642 19.25 21.25 19.25H19.5V20.25C19.5 20.7141 19.3156 21.1592 18.9874 21.4874C18.6592 21.8156 18.2141 22 17.75 22H3.75C3.28587 22 2.84075 21.8156 2.51256 21.4874C2.18437 21.1592 2 20.7141 2 20.25V3.75C2 3.28587 2.18437 2.84075 2.51256 2.51256C2.84075 2.18437 3.28587 2 3.75 2H14.75C14.9048 2 15.0544 2.04782 15.1793 2.13502C15.264 2.18842 15.3374 2.25832 15.3947 2.3402ZM3.57322 3.57322C3.62011 3.52634 3.6837 3.5 3.75 3.5H14.03V6.98C14.03 7.39421 14.3658 7.73 14.78 7.73H18V9.25H7C6.58579 9.25 6.25 9.58579 6.25 10V18.5C6.25 18.9142 6.58579 19.25 7 19.25H18V20.25C18 20.3163 17.9737 20.3799 17.9268 20.4268C17.8799 20.4737 17.8163 20.5 17.75 20.5H3.75C3.68369 20.5 3.62011 20.4737 3.57322 20.4268C3.52634 20.3799 3.5 20.3163 3.5 20.25V3.75C3.5 3.6837 3.52634 3.62011 3.57322 3.57322ZM17.0086 6.23L15.53 4.66643V6.23H17.0086ZM7.75 10.75V17.75H20.5V10.75H7.75Z",
  fill: "#6B8FBC"
})));

const SvgPdfDocument = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdfDocument, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pdf-document.9a5fbcd7.svg";
export { ForwardRef as ReactComponent };